import Find from './find'
export default Find